export const ROOM_DISPLAY_NAME_STORAGE_KEY = 'inshare_room_display_name';
export const DEFAULT_ROOM_DISPLAY_NAME = 'Board Room';

export function getStoredRoomDisplayName(): string {
    try {
        const v = localStorage.getItem(ROOM_DISPLAY_NAME_STORAGE_KEY)?.trim();
        return v || DEFAULT_ROOM_DISPLAY_NAME;
    } catch {
        return DEFAULT_ROOM_DISPLAY_NAME;
    }
}

export function setStoredRoomDisplayName(name: string): void {
    const trimmed = name.trim().slice(0, 120) || DEFAULT_ROOM_DISPLAY_NAME;
    try {
        localStorage.setItem(ROOM_DISPLAY_NAME_STORAGE_KEY, trimmed);
    } catch {
        /* ignore */
    }
}

export function resolvedRoomDisplayName(server?: string): string {
    const s = server?.trim();
    if (s) return s;
    return getStoredRoomDisplayName();
}
